import { render } from "./HeadersAuth.vue?vue&type=template&id=21dae517"
import script from "./HeadersAuth.vue?vue&type=script&lang=js"
export * from "./HeadersAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__